import React, { useEffect, memo } from "react";
import Prism from "prismjs";
import "prismjs/plugins/line-numbers/prism-line-numbers";
import PropTypes from "prop-types";
import "./code.scss";

function Code({ code, language, noScroll }) {
  useEffect(() => {
    Prism.highlightAll();
  }, []);

  return (
    <pre className={`line-numbers ${(noScroll && "noScroll") || ""}`}>
      <code className={language}>{code}</code>
    </pre>
  );
}
Code.defaultProps = {
  noScroll: false,
};
Code.propTypes = {
  code: PropTypes.node.isRequired,
  language: PropTypes.node.isRequired,
  noScroll: PropTypes.bool,
};

export default memo(Code);
